/**
 * Created by shiyonggao on 2019/1/22.
 */

/**
 * 第三方API地址
 * @type {{getParamers: (function(*=))}}
 */
module.exports = {
    /**
     * 默认参数
     */
    PARAMS: {
        server_id: null,
        head: 'Y',
        user_id: null,
        merchant_shop_code: '',
        platform: 'web',
        merchant_id: '',
        tpl: 't1',
        lang: 'en-US',
        footer: 'Y',
        theme: 't1',
        ad_source: '', //渠道来源
    },

    /**
     * 编译时用的变量
     */
    webpath: 'pay/web',
    web_sdk_name: 'pay.sdk.js',
    website: 'pay',

    /**
     * web domain
     */
    host : null,
    host_dev: null,
    host_map_dev_domain: null, //测试环境|生产环境设置null
    host_map_reg_domain: /^(sandbox-pay|sandbox-facebook|facebook|pay|sandbox-widget1|widget1|sandbox-widget2|widget2)\.(.+)(mes|spay)\.(org|com)$/, //兼容老域名规则

    /**
     * 域名的映射关系
     */
    host_map_refix: '.',
    host_maps: {
        /**
         * Sandbox
         */
        'sandbox': {
            'api': 'sandbox-api@pay',
            'channel': 'sandbox-channel@pay',
            'repayment': 'sandbox-repayment@pay',
        },

        /**
         * Production
         */
        'production': {
            'api': 'api@pay',
            'channel': 'channel@pay',
            'repayment': 'repayment@pay',
        }
    },
    
   /**
     * 支付页面引导入口页面
     */
    moduleJumpToEntery: 'index.html',

    //封禁可还款地址
    repaymentUrl : '/web/index.html?server_id=@sid@&user_id=@uid@&merchant_shop_code=@gamecode@&platform=@platform@&merchant_id=@merchant_id@',

    //封禁不可还款提示地址
    unRepaymentTipUrl: '/web/tip.html?server_id=@sid@&user_id=@uid@&merchant_shop_code=@gamecode@&platform=@platform@&merchant_id=@merchant_id@',

    //下单成功回调地址
    orderCallbackUrl: "/page/redirect/index?oid=@oid@",

    //获取模版信息API
    getTemplateUrl : '/api/public/package/template',

    //官网
    www_footer :  'https://profile.@domain@/footer/footer.html?a=widget&m=footer&lang=@lang@&gcode=@gamecode@',

    /**
     * 风格配置
     */
    THEME: {
        t1: 'pay/default',     //通用）Y  tpl=t1 theme=t1
        t2: 'pay/naruto',      //火影（英/西/法/德/葡/意/波/土）Y  tpl=t2  theme=t2
        t3: 'pay/ar'           //tpl = t1 theme=t3
    },


    /**
     * 版本功能
     */
    TPL: {
        't1' : {
            server : 1,
            country : 1,
            packagelist : 1,
            pack: 1,
            prop: 1,
            api: {
                app_base_url : null,
                app_access : '/api/public/package/access/page',
                app_get_server : '/api/public/shop/server/list',
                app_user_info : '/api/public/shop/user/role/list',
                app_user_last: '/api/public/shop/user/last',
                app_logo : '/api/public/shop/logo',
                app_package_info: '/api/public/package/list',
                app_order: '/api/public/order/placed',
                app_check: '/api/public/shop/login/check'
            }
        },
        't2': {
            server: 1,
            country: 2,
            packagelist: 1,
            pack: 1,
            prop: 1,
            api: {
                app_base_url: null,
                app_access: '/api/public/package/access/page',
                app_get_server: '/api/public/shop/server/list',
                app_user_info: '/api/public/shop/user/role/list',
                app_user_last: '/api/public/shop/user/last',
                app_logo: '/api/public/shop/logo',
                app_package_info: '/api/public/package/list',
                app_order: '/api/public/order/placed',
                app_check: '/api/public/shop/login/check'
            }
        }
    },
    getVersionInfo(){
        return this.TPL[this.PARAMS.tpl];
    },

    getThemeValue(){
        return this.THEME[this.PARAMS.theme];
    }
};


// WEBPACK FOOTER //
// ./website/common/config.js